const DEMO_SESSION_KEY = 'aspiredai_demo_session'
const DEMO_MESSAGES_USED_KEY = 'demo_messages_used'

// DemoChat now renders inside the industry landing pages, whose bodies are
// pre-rendered to static HTML by scripts/prerender-industries.mjs — a plain
// Node process with no localStorage and no crypto.randomUUID. Guard every
// browser API so the prerender build cannot crash; the client fills these in
// after mount.
const hasWindow = (): boolean => typeof window !== 'undefined'

export function getDemoSessionKey(): string {
  if (!hasWindow()) return ''
  let key = localStorage.getItem(DEMO_SESSION_KEY)
  if (!key) {
    key = crypto.randomUUID()
    localStorage.setItem(DEMO_SESSION_KEY, key)
  }
  return key
}

export function getDemoMessagesUsed(): number {
  if (!hasWindow()) return 0
  return parseInt(localStorage.getItem(DEMO_MESSAGES_USED_KEY) || '0')
}

export function setDemoMessagesUsed(count: number): void {
  if (!hasWindow()) return
  localStorage.setItem(DEMO_MESSAGES_USED_KEY, String(count))
}

export function clearDemoSession(): void {
  if (!hasWindow()) return
  localStorage.removeItem(DEMO_SESSION_KEY)
  localStorage.removeItem(DEMO_MESSAGES_USED_KEY)
}
